import { render } from "./ModalCAT.vue?vue&type=template&id=3e40e4d4&scoped=true"
import script from "./ModalCAT.vue?vue&type=script&lang=js"
export * from "./ModalCAT.vue?vue&type=script&lang=js"

import "./ModalCAT.vue?vue&type=style&index=0&id=3e40e4d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e40e4d4"]])

export default __exports__